var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("DeleteDialog", {
        attrs: {
          title: "Löschen",
          text: "Benutzer wirklich löschen?",
          deleteMode: _vm.deleteMode,
          confirmCallback: _vm.deleteConfirmCallback
        }
      }),
      _vm._v(" "),
      _vm.showUserForm
        ? _c("UserForm", {
            attrs: {
              "form-action": _vm.userFormAction,
              "user-id": _vm.editUserId
            },
            on: { close: _vm.formCloseHandler }
          })
        : _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("span", [_vm._v("Benutzer")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right", padding: "3px 0" },
                      attrs: { type: "text" },
                      on: { click: _vm.handleCreate }
                    },
                    [_vm._v("Hinzufügen")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row"),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  !_vm.showUserForm
                    ? _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.users }
                        },
                        [
                          _vm._l(_vm.tableColumns, function(col, index) {
                            return _c("el-table-column", {
                              key: index,
                              attrs: {
                                label: col.label,
                                prop: col.prop,
                                align: "center",
                                formatter: col.formatter,
                                width: _vm.getColumnWidth(col)
                              }
                            })
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              fixed: "right",
                              width: "90px"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleEdit(
                                                scope.row.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Bearbeiten")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              4179053197
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              fixed: "right",
                              width: "80px"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm.get_current_user.id !== scope.row.id
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleDelete(
                                                    scope.row.id
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Löschen")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2698251514
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9ab9314", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9ab9314","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/users/Users.vue
// module id = null
// module chunks = 